export { default } from "float-kit/components/d-tooltip";
